import apiClient from './client';
import { API_PATHS } from '../utils/constants';

function toSafeIdentifier(identifier) {
  return encodeURIComponent(String(identifier));
}

function unwrapResponsePayload(responseData) {
  return responseData?.data ?? responseData;
}

function extractArticleList(payload) {
  if (Array.isArray(payload)) {
    return { items: payload, total: payload.length };
  }

  const items =
    payload?.items ||
    payload?.results ||
    payload?.articles ||
    payload?.data ||
    [];

  const total =
    payload?.pagination?.total ||
    payload?.meta?.total ||
    payload?.total ||
    (Array.isArray(items) ? items.length : 0);

  return { items: Array.isArray(items) ? items : [], total };
}

function buildListParams(filters = {}) {
  const searchParams = new URLSearchParams();
  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '' || value === 'all') return;
    searchParams.set(key, value);
  });
  return searchParams.toString();
}

export async function listArticles(filters = {}) {
  const query = buildListParams(filters);
  const endpoint = query ? `${API_PATHS.articles.base}?${query}` : API_PATHS.articles.base;
  const { data } = await apiClient.get(endpoint);
  const payload = unwrapResponsePayload(data);
  return extractArticleList(payload);
}

export async function getArticleByIdentifier(identifier) {
  const { data } = await apiClient.get(`${API_PATHS.articles.base}/${toSafeIdentifier(identifier)}`);
  return unwrapResponsePayload(data);
}

export async function createArticle(payload) {
  const { data } = await apiClient.post(API_PATHS.articles.base, payload);
  return unwrapResponsePayload(data);
}

export async function updateArticle(identifier, payload) {
  const { data } = await apiClient.patch(
    `${API_PATHS.articles.base}/${toSafeIdentifier(identifier)}`,
    payload,
  );
  return unwrapResponsePayload(data);
}

export async function publishArticle(identifier) {
  const { data } = await apiClient.post(
    `${API_PATHS.articles.base}/${toSafeIdentifier(identifier)}/publish`,
  );
  return unwrapResponsePayload(data);
}

export async function unpublishArticle(identifier) {
  const { data } = await apiClient.post(
    `${API_PATHS.articles.base}/${toSafeIdentifier(identifier)}/unpublish`,
  );
  return unwrapResponsePayload(data);
}

export async function archiveArticle(identifier) {
  const { data } = await apiClient.delete(
    `${API_PATHS.articles.base}/${toSafeIdentifier(identifier)}`,
  );
  return unwrapResponsePayload(data);
}
